var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcDeleteFilledActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 6,
    fill: "#FF9E1B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5686 14.7059C21.5686 14.1644 22.0075 13.7255 22.549 13.7255H28.9215C29.463 13.7255 29.9019 14.1644 29.9019 14.7059V17.9412C29.9019 18.4826 29.463 18.9216 28.9215 18.9216C28.3801 18.9216 27.9412 18.4826 27.9412 17.9412V15.6863H23.5294V17.9412C23.5294 18.4826 23.0905 18.9216 22.549 18.9216C22.0075 18.9216 21.5686 18.4826 21.5686 17.9412V14.7059Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9314 18.6275C15.9314 17.6799 16.6995 16.9118 17.6471 16.9118H33.3334C34.2809 16.9118 35.049 17.6799 35.049 18.6275C35.049 19.575 34.2809 20.3431 33.3334 20.3431H17.6471C16.6995 20.3431 15.9314 19.575 15.9314 18.6275Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6079 21.8137C20.5554 21.8137 21.3236 22.5819 21.3236 23.5294V32.7941H30.1471V23.5294C30.1471 22.5819 30.9153 21.8137 31.8628 21.8137C32.8103 21.8137 33.5785 22.5819 33.5785 23.5294V33.5294C33.5785 35.0184 32.3714 36.2255 30.8824 36.2255H20.5883C19.0993 36.2255 17.8922 35.0184 17.8922 33.5294V23.5294C17.8922 22.5819 18.6604 21.8137 19.6079 21.8137Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeleteFilledActive);
export default __webpack_public_path__ + "static/media/ic_delete_filled_active.71f4375907b832fbda8cec279f595ef9.svg";
export { ForwardRef as ReactComponent };